import type { CountryLocale } from "@/locales/fr/country";

import { ECountryCode } from "@/domains/country/country.types.ts";

const country: CountryLocale = {
  [ECountryCode.FRANCE]: "France",
  [ECountryCode.BELGIUM]: "Belgium",
  [ECountryCode.FINLAND]: "Finland",
  [ECountryCode.SLOVENIA]: "Slovenia",
  [ECountryCode.SWEDEN]: "Sweden",
  [ECountryCode.GREAT_BRITAIN]: "United Kingdom",
  [ECountryCode.SPAIN]: "Spain",
  [ECountryCode.CZECH]: "Czech Republic",
  [ECountryCode.HUNGARY]: "Hungary",
};

export default {
  country,
};
